import { useQuery } from '@tanstack/vue-query'
import { toValue, type MaybeRefOrGetter } from 'vue'
import { propertyKeys } from './propertyQueryKeys'
import { getPropertyDetail } from './propertyEndpoints'
import { parsePropertyDetail } from './propertyDetailParser'

export function usePropertyDetailQuery(id: MaybeRefOrGetter<string>) {
  return useQuery({
    queryKey: () => propertyKeys.detail(toValue(id)),
    queryFn: () => getPropertyDetail(toValue(id)).then(parsePropertyDetail),
    enabled: () => Boolean(toValue(id)),
  })
}
